(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["viewers-count"] && !Shopify.designMode) return;
  try {
    (function () {
    var ABACUS = 'https://abacus.jasoncameron.dev';

    function todayKey() {
      var d = new Date();
      return '' + d.getUTCFullYear() +
        ('0' + (d.getUTCMonth() + 1)).slice(-2) +
        ('0' + d.getUTCDate()).slice(-2);
    }

    function sanitize(s) {
      return String(s).replace(/[^A-Za-z0-9_.-]/g, '-');
    }

    // Deterministic 0..1 from a string (FNV-1a) so simulated counts are stable per day.
    function seeded(str) {
      var h = 2166136261;
      for (var i = 0; i < str.length; i++) {
        h ^= str.charCodeAt(i);
        h = Math.imul(h, 16777619);
      }
      return ((h >>> 0) % 100000) / 100000;
    }

    function simToday(el, dayKey) {
      var min = parseInt(el.getAttribute('data-sim-min'), 10) || 20;
      var max = parseInt(el.getAttribute('data-sim-max'), 10) || 140;
      if (max < min) { max = min; }
      var r = seeded(el.getAttribute('data-product-id') + '-' + dayKey);
      return Math.floor(min + r * (max - min + 1));
    }

    function fetchReal(ns, key, increment) {
      var path = increment ? '/hit/' : '/get/';
      var url = ABACUS + path + encodeURIComponent(ns) + '/' + encodeURIComponent(key);
      var ctrl = new AbortController();
      var timer = setTimeout(function () { ctrl.abort(); }, 4000);
      return fetch(url, { signal: ctrl.signal })
        .then(function (res) {
          clearTimeout(timer);
          if (!res.ok) { throw new Error('bad status'); }
          return res.json();
        })
        .then(function (data) {
          return (data && typeof data.value === 'number') ? data.value : null;
        });
    }

    // Estimate "viewing now" from a daily total — modest fraction with jitter.
    function viewingNowFrom(total) {
      var base = Math.max(2, Math.round(total * 0.06));
      var jitter = Math.floor(Math.random() * 3); // 0..2
      return base + jitter;
    }

    function render(el, count) {
      if (count === null || isNaN(count)) { return; }
      var minCount = parseInt(el.getAttribute('data-min-count'), 10) || 0;
      var label = el.getAttribute('data-label');
      var numberEl = el.querySelector('[data-vc-number]');
      var msgEl = el.querySelector('[data-vc-message]');
      var template = label === 'viewing_now'
        ? el.getAttribute('data-text-now')
        : el.getAttribute('data-text-today');

      var display = count;
      if (label === 'viewing_now') {
        // For viewing-now the threshold applies to the daily activity, not the
        // small live estimate; el.dataset.today holds the day total.
        var dayTotal = parseInt(el.getAttribute('data-today-total'), 10);
        if (!isNaN(dayTotal) && dayTotal < minCount) { return; }
      } else if (count < minCount) {
        return;
      }

      numberEl.textContent = display;
      // Strip a leading "[count]" token from the message if present.
      msgEl.textContent = ' ' + template.replace('[count]', '').trim();
      el.hidden = false;
    }

    function startNowTicker(el, dayTotal) {
      el.setAttribute('data-today-total', dayTotal);
      function tick() { render(el, viewingNowFrom(dayTotal)); }
      tick();
      setInterval(tick, 25000);
    }

    function initEl(el) {
      if (el.dataset.vcReady) { return; }
      el.dataset.vcReady = '1';

      var mode = el.getAttribute('data-mode');
      var label = el.getAttribute('data-label');
      var pid = el.getAttribute('data-product-id');
      var dayKey = todayKey();

      if (!pid || pid === '') { return; }

      if (mode === 'simulated') {
        var t = simToday(el, dayKey);
        if (label === 'viewing_now') {
          startNowTicker(el, t);
        } else {
          render(el, t);
        }
        return;
      }

      // Real mode
      var ns = sanitize(el.getAttribute('data-shop') || 'shop');
      var key = 'pid' + sanitize(pid) + '-' + dayKey;
      var seenKey = 'vc-seen-' + key;
      var alreadySeen = false;
      try { alreadySeen = !!localStorage.getItem(seenKey); } catch (e) {}

      fetchReal(ns, key, !alreadySeen)
        .then(function (value) {
          if (!alreadySeen) {
            try { localStorage.setItem(seenKey, '1'); } catch (e) {}
          }
          if (value === null) { throw new Error('no value'); }
          if (label === 'viewing_now') {
            startNowTicker(el, value);
          } else {
            render(el, value);
          }
        })
        .catch(function () {
          // Graceful fallback to simulated so the page never shows a broken state.
          var t = simToday(el, dayKey);
          if (label === 'viewing_now') {
            startNowTicker(el, t);
          } else {
            render(el, t);
          }
        });
    }

    function initAll() {
      var els = document.querySelectorAll('viewers-count');
      for (var i = 0; i < els.length; i++) { initEl(els[i]); }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
